// extracted by mini-css-extract-plugin
export default {"confirmContent":"ConfirmDialog-module__confirmContent_zu4sh"};